import {Injectable} from "@angular/core";
import {environment as global_env} from '@env/environment';

@Injectable({ providedIn: 'root' })
export class Utiles_ferramentas{

  async isNumericString(str: string): Promise<boolean> {
    return /^\d+$/.test(str);
  }


    /**
     * Limpia un texto eliminando caracteres especiales,
     * pero mantiene los caracteres propios del portugués brasileño.
     * @param texto Texto de entrada
     * @returns Texto limpio
     */
    async clearTextPortugues(texto: string):  Promise<string>  {
        if (!texto) return '';
        return texto
            .normalize('NFC') // Mantiene la forma compuesta de caracteres acentuados
            .replace(/[^a-zA-Z0-9\sáàâãäéèêëíìîïóòôõöúùûüçÁÀÂÃÄÉÈÊËÍÌÎÏÓÒÔÕÖÚÙÛÜÇ]/g, '');
    }

  /**
   * Verifica se uma string contém exclusivamente caracteres numéricos e/o os caracteres especiais especificados.
   * A função segue a lógica de "lista permitida": a string é válida se todos os seus caracteres
   * forem números (0-9) ou estiverem incluídos na string 'omit'.
   *
   * @param str A string de entrada para validar. Se for nula, indefinida ou vazia, a função retornará `false`.
   * @param omit Uma string que contém todos os caracteres especiais que são permitidos na validação. Por exemplo, se omit = ".-", a string "123-45.6" seria válida.
   * @returns Retorna uma Promise que resolve para `true` se a string for válida, e `false` caso contrário.
   */
  async isNumericStringWithSpecialCharacters(str: string, omit: string = ''): Promise<boolean> {
    if (!str) {
      return false;
    }
    const escapedOmitChars = omit.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    const validationRegex = new RegExp(`^[0-9${escapedOmitChars}]+$`);
    return validationRegex.test(str);
  }

  async cleaned_number(number:string): Promise<string> {
    if (!number) return '';
    return number.replace(/[^0-9]/g, '');
  }

  async validateCPF(cpf: string): Promise<{ valid: boolean, reason: string }> {
    let reason: string = 'CPF inválido razões: '
    let valid: boolean = true;
    cpf = cpf.replace(/\D/g, '');
    if (cpf.length !== 11) {
      reason += 'O CPF o documento fornecido não possui 11 dígitos'
      return {valid: false, reason: reason};
    }
    // Verifique se todos os dígitos são iguais (caso contrário, o CPF é inválido)
    const digitosIguais = cpf.split('').every(d => d === cpf[0]);
    if (digitosIguais) {
      return {valid: false, reason: reason};
    }
    return {valid: true, reason: reason};
  }
}
